import noUiSlider, { API } from 'nouislider';
import wNumb, { Instance } from 'wnumb';

import Component from '../../component/component';

import 'nouislider/dist/nouislider.css';
import './range.scss';

export interface IRangeSettings {
    focusClass?: string;
    inputClass?: string;
    sliderClass?: string;
    valueClass?: string;
    dirtyClass?: string;
    valueMinClass?: string;
    valueMaxClass?: string;
}

export const rangeSettings: IRangeSettings = {
    dirtyClass: 'is-dirty',
    focusClass: 'is-focused',
    inputClass: 'range__input-value',
    sliderClass: 'range__slider',
    valueClass: 'range__value',
    valueMaxClass: 'range__value--max span',
    valueMinClass: 'range__value--min span',
};

export default class Range extends Component {
    static initSelector: string = '.js-range';
    static rangeSliders: Range[] = [];

    public settings: IRangeSettings;

    slider: HTMLElement;
    value: JQuery;
    sliderContainer: API;
    rangeInputValue: JQuery;
    minRange: number;
    maxRange: number;
    valueMin: JQuery;
    valueMax: JQuery;
    step: number;
    isMulti: boolean;
    startValue: number;

    constructor(target: HTMLElement, settings: IRangeSettings = {}) {
        super(target);

        this.settings = jQuery.extend(rangeSettings, settings) as IRangeSettings;
        this.slider = this.element.find('.' + this.settings.sliderClass).get(0);
        this.value = this.element.find('.' + this.settings.valueClass);
        this.rangeInputValue = this.element.find('.' + this.settings.inputClass);
        this.isMulti = this.element.data('multi') === true ? true : false;
        this.startValue = parseInt(this.rangeInputValue.val().toString());

        if (this.isMulti) {
            this.valueMin = this.element.find('.' + this.settings.valueMinClass);
            this.valueMax = this.element.find('.' + this.settings.valueMaxClass);
        }

        this.element.on('update', this.update.bind(this));
        this.init();
    }

    static resetAll(): void {
        const format: Instance = wNumb({
            thousand: ' ',
        });

        Range.rangeSliders.forEach((sliderInstance: Range): void => {
            sliderInstance.element.find('.range__value--min span').html(format.to(sliderInstance.minRange));
            sliderInstance.element.find('.range__value--max span').html(format.to(sliderInstance.maxRange));
            sliderInstance.sliderContainer.reset();
            sliderInstance.rangeInputValue.val(0);
        });
    }

    update(): void {
        this.minRange = this.element.data('min');
        this.maxRange = this.element.data('max');
        let startHandles: number[];

        if (this.isMulti) {
            startHandles = [this.startValue, this.maxRange];
        } else {
            startHandles = [this.startValue];
        }

        this.sliderContainer.updateOptions({
            range: {
                max: this.maxRange,
                min: this.minRange,
            },
            start: startHandles,
        }, true);
    }

    init(): void {
        this.minRange = this.element.data('min');
        this.maxRange = this.element.data('max');
        this.step = this.element.data('step') ? parseInt(this.element.data('step')) : 10000;

        const format: Instance = wNumb({
            thousand: ' ',
        });

        if (this.isMulti) {
            this.valueMax.html(format.to(this.maxRange));
            this.valueMin.html(format.to(this.startValue));
        } else {
            this.value.html(format.to(this.startValue));
        }

        let startHandles: number[];

        if (this.isMulti) {
            startHandles = [this.startValue, this.maxRange];
        } else {
            startHandles = [this.startValue];
        }

        this.sliderContainer = noUiSlider.create(this.slider, {
            connect: this.isMulti ? true : 'lower',
            format: {
                from: (value: string): number => parseInt(value),
                to: (value: number): string => {
                    const valueFloor: string = Math.floor(value).toString();
                    const remainder: number = valueFloor.length % 3;

                    return (valueFloor.substr(0, remainder) + valueFloor.substr(remainder).replace(/(\d{3})/g, '$1')).trim();
                },
            },
            range: {
                max: this.maxRange,
                min: this.minRange,
            },
            start: startHandles,
            step: this.step,
        });

        this.sliderContainer.on('slide', (values: string[], handle: number) => {
            if (this.isMulti) {
                // change active state
                if (parseInt(values[0]) !== this.minRange || parseInt(values[1]) !== this.maxRange) {
                    this.element.addClass(this.settings.dirtyClass);
                }

                const min: string = format.to(parseInt(values[0]));
                const max: string = format.to(parseInt(values[1]));

                this.valueMin.html(min);
                this.valueMax.html(max);
            } else {
                // change active state
                if (parseInt(this.value.html()) !== this.minRange) {
                    this.element.addClass(this.settings.dirtyClass);
                }

                this.value.html(format.to(parseInt(values[handle])));
            }
            this.rangeInputValue.val(values);
        });

        this.sliderContainer.on('change', () => {
            $(document).trigger('range.onChange');
        });

        this.element.data('sliderContainer', this.sliderContainer);

        if (this.element.hasClass('range--filter')) {
            Range.rangeSliders.push(this);
        }
    }
}
